module.exports = __webpack_public_path__ + "img/52114147_L.5019b847.png";